import store from '@/store'
import VueGeolocation from 'vue-browser-geolocation'
import utils from '@/utils'

/**
 * 位置情報
 */
export default {
  state: {
    // 地図の初期値（エラー時などに利用）
    mapDefaultLocation: { lat: 34.693240, lng: 135.526040 },
    // 位置情報
    location: null,
    // 保存時間
    saveTime: null
  },
  getters: {
    /**
     * 位置情報
     */
    geo_location (state) {
      return state.location || store.state.apps.mapDefaultLocation
    }
  },
  actions: {
    /**
     * 位置情報を読込
     */
    geo_read ({state, dispatch, commit}) {
      if (state.saveTime !== null) {
        const nextTime = state.saveTime + process.env.VUE_APP_GEO_PERIOD
        if (nextTime >= Date.now()) {
          return Promise.resolve()
        }
      }

      return VueGeolocation.getLocation({timeout: process.env.VUE_APP_GEO_TIMEOUT})
        .then(coordinates => {
          commit('geo_location', coordinates)
          commit('geo_saveTime', Date.now())
        })
        .catch((error) => utils.debug.error(error))
    }
  },
  mutations: {
    /**
     * 位置情報
     */
    geo_location (state, value) {
      state.location = value
    },
    /**
     * 保存時間
     */
    geo_saveTime (state, value) {
      state.saveTime = value
    }
  }
}
